export default "__VITE_ASSET__00dd5f56__"